import { OctagonX } from 'lucide-react';
import { AbortTripButton } from './AbortTripButton';

interface AbortPanelProps {
  tripId: string;
  /** Whether the trip is in a state it can be aborted from, and the user may. */
  canAbort: boolean;
  onAborted: () => void;
}

/** Stopping a trip that was dispatched and will not complete (gitaumoses4/chukua#472). Not rendered when the user cannot. */
export function AbortPanel({ tripId, canAbort, onAborted }: AbortPanelProps) {
  if (!canAbort) return null;
  return (
    <section aria-label="Abort trip" className="rounded-lg border border-line bg-surface p-5">
      <div className="flex items-center justify-between gap-3">
        <div>
          <h2 className="flex items-center gap-2 text-base font-semibold text-fg">
            <OctagonX className="size-5 text-muted" aria-hidden /> Abort trip
          </h2>
          <p className="mt-1 text-sm text-muted">For a trip that will not complete. The crew is freed and unspent cash is taken back.</p>
        </div>
        <AbortTripButton tripId={tripId} onAborted={onAborted} />
      </div>
    </section>
  );
}
